import React from "react";
import { StyledList } from "components/molecules/ExampleList/ExampleList.styles.js";
export default function ExampleList({ ExampleListData, lang }) {
  let list;
  if (lang === "pl") {
    list = ExampleListData.items.pl;
  } else if (lang === "en") {
    list = ExampleListData.items.en;
  } else {
    list = ExampleListData.items.pl;
  }
  return (
    <StyledList>
      <p>
        {lang === "pl" ? ExampleListData.title.pl : ExampleListData.title.en}
      </p>
      <ul>
        {list.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </StyledList>
  );
}
